/*
  Clean version v2:
  - Variant IDs are used for prices, cart, and checkout.
  - Product handles are used for hover-card images, titles, and descriptions.
  - VersaClip uses the confirmed Shopify handle: versa-clip.
  - ColorGard and Colour Strip keep fallback handles because their images need them.
  - CSS and Liquid section do not need changes.
*/

'use strict';

    const RAIL_LENGTH_INCHES = 92;
    const HST_RATE = 0.13;
    const OUTSIDE_GTA_DELIVERY_FEE = 300;

    const SHOPIFY_PRODUCTS = {
      colorGardRail: {
        variantId: '51846347718952',
        handle: 'colorgard-unpunched-92',
        handles: [
          'colorgard-unpunched-92',
          'colorgard-unpunched',
          'color-gard-unpunched-92',
          's-5-colorgard',
          'colorgard'
        ]
      },
      splice: {
        variantId: '51846352077096',
        handle: 'splice',
        handles: ['splice']
      },
      snowClipII: {
        variantId: '51846352765224',
        handle: 'snow-clip-ii',
        handles: ['snow-clip-ii', 'snoclip-ii-2-0', 'sno-clip-ii-2-0']
      },
      versaClip: {
        variantId: '51846353518888',
        handle: 'versa-clip',
        handles: ['versa-clip']
      },
      s5sClamp: {
        variantId: '51846357483816',
        handle: 's-5-s-clamp',
        handles: ['s-5-s-clamp']
      },
      s5eClamp: {
        variantId: '51846355845416',
        handle: 's-5-e-clamp',
        handles: ['s-5-e-clamp']
      },
      s5nhClamp: {
        variantId: '51846360695080',
        handle: 's-5-n-1-5-clamp',
        handles: ['s-5-n-1-5-clamp', 's-5-nh-clamp', 's-5-n-clamp']
      },
      colourStrip: {
        variantId: '51846369247528',
        handle: 'colour-strip',
        handles: [
          'colour-strip',
          'color-strip',
          'colorgard-colour-strip',
          'colorgard-color-strip',
          'color-gard-colour-strip',
          'color-gard-color-strip'
        ]
      }
    };

    // Variant IDs are used for pricing, cart, and checkout.
    // Product handles are used for hover-card images, titles, and descriptions.
    // All Shopify requests use relative URLs so the calculator keeps working after store migration.

    const CLAMP_BY_SEAM_TYPE = {
      single_fold: { name: 'S-5-S Clamp', key: 's5sClamp' },
      double_fold: { name: 'S-5-E Clamp', key: 's5eClamp' },
      snap_lock: { name: 'S-5-S Clamp', key: 's5sClamp' },
      nail_strip: { name: 'S-5-N 1.5 Clamp', key: 's5nhClamp' }
    };

    const SEAM_TYPE_LABELS = {
      single_fold: 'Single fold 1-1/2"',
      double_fold: 'Double fold 1-1/2"',
      snap_lock: 'Snap lock 1-1/2"',
      nail_strip: 'Nail Strip 1-1/2"'
    };

    const LAYOUT_LABELS = {
      every_other: 'Clamp on every other seam',
      every_seam: 'Clamp on every seam'
    };

    let currentMaterials = [];
    let priceLoadToken = 0;


    function getInputText(id) {
      const el = document.getElementById(id);
      return el ? String(el.value || '') : '';
    }

    function getInputNumber(id) {
      const el = document.getElementById(id);
      return el ? parseFloat(el.value) || 0 : 0;
    }

    function roundUp(value) {
      return Math.ceil(Math.max(Number(value) || 0, 0));
    }

    function money(value) {
      return '$' + (Number(value) || 0).toLocaleString(undefined, { minimumFractionDigits: 2, maximumFractionDigits: 2 });
    }

    function setSelectOptions(selectId, values, preferredValue) {
      const select = document.getElementById(selectId);
      if (!select) return;
      select.textContent = '';
      values.forEach(function(item) {
        const option = document.createElement('option');
        option.value = item.value;
        option.textContent = item.label;
        select.appendChild(option);
      });
      select.value = values.some(function(item) { return item.value === preferredValue; }) ? preferredValue : values[0].value;
    }

    function populatePitchOptions() {
      const values = [];
      for (let i = 1; i <= 24; i += 1) values.push({ value: String(i), label: i + '/12' });
      setSelectOptions('pitch', values, '6');
    }

    function populateSeamSpacingOptions() {
      const values = [];
      for (let i = 10; i <= 20; i += 1) values.push({ value: String(i), label: i + '"' });
      setSelectOptions('seamSpacing', values, '16');
    }

    function selectedClamp() {
      return CLAMP_BY_SEAM_TYPE[getInputText('seamType')] || CLAMP_BY_SEAM_TYPE.single_fold;
    }

    function selectedPitchNumber() {
      return parseInt(getInputText('pitch'), 10) || 0;
    }

    function selectedRowCount() {
      return parseInt(getInputText('rowCount'), 10) || 1;
    }

    function buildMaterial(key, name, qty, unit) {
      const shopifyProduct = SHOPIFY_PRODUCTS[key] || {};
      const variantId = shopifyProduct.variantId || '';
      const handle = shopifyProduct.handle || '';
      const handles = Array.isArray(shopifyProduct.handles) ? shopifyProduct.handles : (handle ? [handle] : []);
      const cachedVariant = variantId ? shopifyVariantCache[variantId] : null;
      const unitCost = cachedVariant ? shopifyVariantPrice(cachedVariant) : null;

      return {
        key: key,
        name: name,
        variantId: variantId,
        handle: handle,
        handles: handles,
        qty: qty,
        unit: unit,
        unitCost: unitCost,
        totalCost: unitCost === null ? null : qty * unitCost
      };
    }

    function selectedClampLayout() {
      return getInputText('clampLayout') || 'every_other';
    }

    function deliveryFee() {
      return getInputText('needDelivery') === 'outside_gta' ? OUTSIDE_GTA_DELIVERY_FEE : 0;
    }

    function seamRatioPerRow(eavesFt, seamSpacingInches) {
      if (eavesFt <= 0 || seamSpacingInches <= 0) return 0;
      return (eavesFt * 12) / seamSpacingInches;
    }

    function calculateAccessoryQtyPerRow(eavesFt, seamSpacingInches, layout, accessoryType) {
      const seamRatio = seamRatioPerRow(eavesFt, seamSpacingInches);
      if (seamRatio <= 0) return 0;

      if (accessoryType === 'snoClip') return Math.ceil(seamRatio) + 1;
      if (layout === 'every_seam') return Math.ceil(seamRatio) + 1;
      return Math.ceil(seamRatio / 2) + 1;
    }

    function updateValidationMessage(eavesFt) {
      const cartMessage = document.getElementById('cartMessage');
      if (!cartMessage) return;

      if (eavesFt <= 0) {
        cartMessage.style.display = 'block';
        cartMessage.className = 'message cart-message error';
        cartMessage.textContent = 'Enter an eaves length greater than 0 ft to calculate materials.';
        return;
      }

      if (cartMessage.textContent === 'Enter an eaves length greater than 0 ft to calculate materials.') {
        cartMessage.style.display = 'none';
        cartMessage.textContent = '';
      }
    }

    function calculateMaterials() {
      const eavesFt = getInputNumber('eaves');
      const rows = selectedRowCount();
      const seamSpacingInches = getInputNumber('seamSpacing') || 16;
      const clampLayout = selectedClampLayout();
      const clamp = selectedClamp();
      const railQtyPerRow = roundUp((eavesFt * 12) / RAIL_LENGTH_INCHES);
      const railQty = railQtyPerRow * rows;
      const spliceQty = Math.max(railQtyPerRow - 1, 0) * rows;
      const snoClipQty = calculateAccessoryQtyPerRow(eavesFt, seamSpacingInches, clampLayout, 'snoClip') * rows;
      const versaClipQty = calculateAccessoryQtyPerRow(eavesFt, seamSpacingInches, clampLayout, 'versaClip') * rows;
      const clampQty = calculateAccessoryQtyPerRow(eavesFt, seamSpacingInches, clampLayout, 'clamp') * rows;

      currentMaterials = [
        buildMaterial('colorGardRail', 'ColorGard Unpunched - 92"', railQty, 'EA'),
        buildMaterial('splice', 'Splice', spliceQty, 'EA'),
        buildMaterial('snowClipII', 'SnoClip II 2.0', snoClipQty, 'EA'),
        buildMaterial('versaClip', 'VersaClip 2.0', versaClipQty, 'EA'),
        buildMaterial(clamp.key, clamp.name, clampQty, 'EA'),
        buildMaterial('colourStrip', 'Colour Strip', railQty, 'EA')
      ].filter(function(item) { return item.qty > 0; });

      updateWarnings();
      updateValidationMessage(eavesFt);
      updateSummary(eavesFt, railQty, rows, clamp);
      renderMaterials();
      updateDisplayedTotals();
      loadShopifyPricesForMaterials(currentMaterials);
      return currentMaterials;
    }

    function updateWarnings() {
      const pitch = selectedPitchNumber();
      const warning = document.getElementById('pitchWarning');
      const deliveryNotice = document.getElementById('deliveryNotice');
      const delivery = getInputText('needDelivery');

      warning.classList.toggle('visible', pitch >= 10);
      deliveryNotice.classList.toggle('visible', delivery !== 'no');
    }

    function updateSummary(eavesFt, railQty, rows, clamp) {
      document.getElementById('sumEaves').textContent = eavesFt.toLocaleString() + ' ft';
      document.getElementById('sumRails').textContent = railQty + ' pcs';
      document.getElementById('sumClampType').textContent = clamp.name;
      document.getElementById('sumRows').textContent = rows + ' row' + (rows === 1 ? '' : 's');
    }


    /* =========================================================
       Product Hover Preview Feature
       Uses Shopify variant IDs for price/cart data and Shopify product
       handles for images, product titles, and descriptions.
       ========================================================= */

    let productHoverCardEl = null;
    let productHoverHideTimer = null;
    const shopifyVariantCache = {};
    const shopifyProductCache = {};

    function escapeHtml(value) {
      return String(value || '')
        .replace(/&/g, '&amp;')
        .replace(/</g, '&lt;')
        .replace(/>/g, '&gt;')
        .replace(/"/g, '&quot;')
        .replace(/'/g, '&#039;');
    }

    function ensureProductHoverCard() {
      if (productHoverCardEl) return productHoverCardEl;

      productHoverCardEl = document.createElement('div');
      productHoverCardEl.className = 'product-hover-card';
      document.body.appendChild(productHoverCardEl);

      return productHoverCardEl;
    }

    async function fetchShopifyVariantById(variantId) {
      if (!variantId) return null;

      if (shopifyVariantCache[variantId]) {
        return shopifyVariantCache[variantId];
      }

      const response = await fetch('/variants/' + encodeURIComponent(variantId) + '.js', {
        headers: { 'Accept': 'application/json' }
      });

      if (!response.ok) {
        throw new Error('Failed to load Shopify variant.');
      }

      const variant = await response.json();
      shopifyVariantCache[variantId] = variant;
      return variant;
    }

    async function fetchShopifyProductByHandle(handle) {
      if (!handle) return null;

      if (shopifyProductCache[handle]) {
        return shopifyProductCache[handle];
      }

      const response = await fetch('/products/' + encodeURIComponent(handle) + '.js', {
        headers: { 'Accept': 'application/json' }
      });

      if (!response.ok) {
        shopifyProductCache[handle] = null;
        throw new Error('Failed to load Shopify product.');
      }

      const product = await response.json();
      shopifyProductCache[handle] = product;
      return product;
    }

    async function fetchShopifyProductByHandles(handles) {
      const list = (Array.isArray(handles) ? handles : [handles])
        .filter(function(handle, index, source) {
          return handle && source.indexOf(handle) === index;
        });

      for (let i = 0; i < list.length; i += 1) {
        const product = await fetchShopifyProductByHandle(list[i]).catch(function() {
          return null;
        });

        if (product) return product;
      }

      return null;
    }

    function productHandleFromUrl(url) {
      const match = String(url || '').match(/\/products\/([^/?#]+)/);
      return match ? decodeURIComponent(match[1]) : '';
    }

    async function fetchShopifyProductFromSearchTerm(term) {
      if (!term) return null;

      const response = await fetch(
        '/search/suggest.json?q=' + encodeURIComponent(term) + '&resources[type]=product&resources[limit]=5',
        { headers: { 'Accept': 'application/json' } }
      );

      if (!response.ok) return null;

      const data = await response.json();
      const products = data && data.resources && data.resources.results && data.resources.results.products;

      if (!Array.isArray(products) || !products.length) return null;

      for (let i = 0; i < products.length; i += 1) {
        const candidate = products[i];
        const handle = candidate.handle || productHandleFromUrl(candidate.url);

        if (handle) {
          const product = await fetchShopifyProductByHandle(handle).catch(function() {
            return null;
          });

          if (product) return product;
        }

        if (candidate.image || candidate.featured_image) {
          return candidate;
        }
      }

      return null;
    }

    async function fetchShopifyProductForItem(item) {
      const productByHandle = await fetchShopifyProductByHandles(item.handles || item.handle).catch(function() {
        return null;
      });

      if (productByHandle && productImageUrl(productByHandle)) return productByHandle;

      const terms = (Array.isArray(item.searchTerms) ? item.searchTerms : [item.name])
        .filter(function(term, index, source) {
          return term && source.indexOf(term) === index;
        });

      for (let i = 0; i < terms.length; i += 1) {
        const productBySearch = await fetchShopifyProductFromSearchTerm(terms[i]).catch(function() {
          return null;
        });

        if (productBySearch && productImageUrl(productBySearch)) return productBySearch;
      }

      return productByHandle;
    }

    function stripHtml(value) {
      const div = document.createElement('div');
      div.innerHTML = String(value || '');
      return (div.textContent || div.innerText || '').replace(/\s+/g, ' ').trim();
    }

    function truncateText(value, maxLength) {
      const text = String(value || '').trim();
      if (!text || text.length <= maxLength) return text;
      return text.slice(0, maxLength - 1).trim() + '…';
    }

    function shopifyVariantPrice(variant) {
      if (!variant || variant.price === undefined || variant.price === null) return null;

      if (typeof variant.price === 'number') {
        return variant.price > 100 ? variant.price / 100 : variant.price;
      }

      const raw = String(variant.price).replace(/[^0-9.]/g, '');
      if (!raw) return null;

      const parsed = Number(raw);
      if (!Number.isFinite(parsed)) return null;

      return raw.indexOf('.') === -1 && parsed > 100 ? parsed / 100 : parsed;
    }

    async function loadShopifyPricesForMaterials(materials) {
      const token = ++priceLoadToken;
      const variantIds = materials
        .map(function(item) { return item.variantId; })
        .filter(function(variantId, index, list) {
          return variantId && list.indexOf(variantId) === index && !shopifyVariantCache[variantId];
        });

      if (!variantIds.length) {
        applyVariantPricesToMaterials(materials);
        return materials;
      }

      await Promise.all(variantIds.map(function(variantId) {
        return fetchShopifyVariantById(variantId).catch(function() { return null; });
      }));

      if (token !== priceLoadToken) return materials;

      applyVariantPricesToMaterials(materials);
      renderMaterials();
      updateDisplayedTotals();
      return materials;
    }

    function applyVariantPricesToMaterials(materials) {
      materials.forEach(function(item) {
        const variant = item.variantId ? shopifyVariantCache[item.variantId] : null;
        const unitCost = shopifyVariantPrice(variant);
        item.unitCost = unitCost;
        item.totalCost = unitCost === null ? null : item.qty * unitCost;
      });
    }

    function imageSource(value) {
      if (!value) return '';
      if (typeof value === 'string') return value;
      return value.src || value.url || value.preview_image || '';
    }

    function variantImageUrl(variant) {
      if (!variant) return '';

      return imageSource(variant.featured_image) ||
        imageSource(variant.image) ||
        imageSource(variant.image_url);
    }

    function productImageUrl(product) {
      if (!product) return '';

      const featuredImage = imageSource(product.featured_image) || imageSource(product.image);
      if (featuredImage) return featuredImage;

      if (product.images && product.images.length) {
        return imageSource(product.images[0]);
      }

      if (product.media && product.media.length) {
        for (let i = 0; i < product.media.length; i += 1) {
          const media = product.media[i];
          const mediaImage = imageSource(media.preview_image) || imageSource(media);
          if (mediaImage) return mediaImage;
        }
      }

      return '';
    }

    function positionProductHoverCard(event) {
      if (!productHoverCardEl || productHoverCardEl.style.display !== 'block') return;

      let left = event.clientX + 18;
      let top = event.clientY + 18;

      const rect = productHoverCardEl.getBoundingClientRect();

      if (left + rect.width > window.innerWidth - 12) {
        left = window.innerWidth - rect.width - 12;
      }

      if (top + rect.height > window.innerHeight - 12) {
        top = window.innerHeight - rect.height - 12;
      }

      productHoverCardEl.style.left = left + 'px';
      productHoverCardEl.style.top = top + 'px';
    }

    async function showProductHoverCard(event, item) {
      clearTimeout(productHoverHideTimer);

      if (!item || !item.variantId) return;

      const card = ensureProductHoverCard();

      card.innerHTML =
        '<div class="product-hover-image-wrap">' +
          '<div class="product-hover-image-placeholder">Loading product preview...</div>' +
        '</div>' +
        '<div class="product-hover-content">' +
          '<div class="product-hover-title-text">' + escapeHtml(item.name) + '</div>' +
          '<div class="product-hover-description">Loading Shopify product information.</div>' +
        '</div>';

      card.style.display = 'block';
      positionProductHoverCard(event);

      const results = await Promise.all([
        fetchShopifyVariantById(item.variantId).catch(function() { return null; }),
        fetchShopifyProductByHandles(item.handles || item.handle).catch(function() { return null; })
      ]);

      const variant = results[0];
      const product = results[1];

      if (!variant && !product) {
        card.innerHTML =
          '<div class="product-hover-content">' +
            '<div class="product-hover-title-text">' + escapeHtml(item.name) + '</div>' +
            '<div class="product-hover-description">Product preview is not available right now.</div>' +
            '<div class="product-hover-meta">' +
              '<span class="product-hover-badge">Variant: ' + escapeHtml(item.variantId) + '</span>' +
              (item.handle ? '<span class="product-hover-badge">Handle: ' + escapeHtml(item.handle) + '</span>' : '') +
            '</div>' +
          '</div>';
        positionProductHoverCard(event);
        return;
      }

      const image = productImageUrl(product) || variantImageUrl(variant);
      const title = (product && product.title) || (variant && variant.name) || item.name;
      const description = truncateText(stripHtml(product && (product.description || product.body_html)), 160) || 'Product description is not available.';
      const sku = (variant && variant.sku) || 'N/A';
      const availability = variant && variant.available ? 'Available' : 'Unavailable';
      const variantInfo = (variant && (variant.public_title || variant.title || variant.name)) || item.variantId;

      card.innerHTML =
        '<div class="product-hover-image-wrap">' +
          (image
            ? '<img class="product-hover-image" src="' + escapeHtml(image) + '" alt="' + escapeHtml(title) + '" />'
            : '<div class="product-hover-image-placeholder">No product image available</div>') +
        '</div>' +
        '<div class="product-hover-content">' +
          '<div class="product-hover-title-text">' + escapeHtml(title) + '</div>' +
          '<div class="product-hover-description">' + escapeHtml(description) + '</div>' +
          '<div class="product-hover-meta">' +
            '<span class="product-hover-badge">Variant: ' + escapeHtml(variantInfo) + '</span>' +
            '<span class="product-hover-badge">SKU: ' + escapeHtml(sku) + '</span>' +
            '<span class="product-hover-badge">' + escapeHtml(item.unit) + '</span>' +
            '<span class="product-hover-badge">' + escapeHtml(availability) + '</span>' +
          '</div>' +
        '</div>';

      positionProductHoverCard(event);
    }

    function hideProductHoverCard() {
      productHoverHideTimer = setTimeout(function() {
        if (productHoverCardEl) {
          productHoverCardEl.style.display = 'none';
        }
      }, 90);
    }

    function createMaterialNameCell(item) {
      const td = document.createElement('td');
      const strong = document.createElement('strong');

      strong.className = item.variantId ? 'material-hover-title' : '';
      strong.textContent = item.name;

      if (item.variantId) {
        strong.addEventListener('mouseenter', function(event) {
          showProductHoverCard(event, item);
        });

        strong.addEventListener('mousemove', positionProductHoverCard);
        strong.addEventListener('mouseleave', hideProductHoverCard);
      }

      td.appendChild(strong);
      return td;
    }

    function renderMaterials() {
      const body = document.getElementById('materialsBody');
      body.textContent = '';

      currentMaterials.forEach(function(item) {
        const row = document.createElement('tr');
        row.appendChild(createMaterialNameCell(item));
        row.appendChild(createCell(String(item.qty), 'qty'));
        row.appendChild(createCell(item.unit));
        row.appendChild(createCell(item.unitCost === null ? 'Loading...' : money(item.unitCost), 'money'));
        row.appendChild(createCell(item.totalCost === null ? 'Loading...' : money(item.totalCost), 'money'));
        body.appendChild(row);
      });
    }

    function updateDisplayedTotals() {
      const isLoadingPrices = currentMaterials.some(function(item) { return item.unitCost === null; });
      const delivery = deliveryFee();

      if (isLoadingPrices) {
        document.getElementById('subtotalAmount').textContent = 'Loading...';
        document.getElementById('deliveryAmount').textContent = money(delivery);
        document.getElementById('hstAmount').textContent = 'Loading...';
        document.getElementById('totalWithTaxAmount').textContent = 'Loading...';
        return;
      }

      const materialsSubtotal = currentMaterials.reduce(function(sum, item) { return sum + (item.totalCost || 0); }, 0);
      const taxableSubtotal = materialsSubtotal + delivery;
      const hst = taxableSubtotal * HST_RATE;
      const totalWithTax = taxableSubtotal + hst;
      document.getElementById('subtotalAmount').textContent = money(materialsSubtotal);
      document.getElementById('deliveryAmount').textContent = money(delivery);
      document.getElementById('hstAmount').textContent = money(hst);
      document.getElementById('totalWithTaxAmount').textContent = money(totalWithTax);
    }

    function createCell(text, className) {
      const td = document.createElement('td');
      if (className) td.className = className;
      td.textContent = text;
      return td;
    }

    function sanitizeNumberInput(input) {
      if (!input || input.type !== 'number') return;
      input.value = String(input.value || '').replace(/[^0-9.]/g, '').replace(/(\..*)\./g, '$1');
    }

    function setupAutoCalculate() {
      document.querySelectorAll('input[type="number"]').forEach(function(input) {
        input.setAttribute('inputmode', 'decimal');
        input.addEventListener('keydown', function(event) {
          if (['e', 'E', '+', '-'].includes(event.key)) event.preventDefault();
        });
        input.addEventListener('input', function() {
          sanitizeNumberInput(input);
          calculateMaterials();
        });
      });

      document.querySelectorAll('input[type="text"], select').forEach(function(control) {
        control.addEventListener('input', calculateMaterials);
        control.addEventListener('change', calculateMaterials);
      });
    }

    function resetCalculator() {
      document.getElementById('projectName').value = '';
      document.getElementById('projectAddress').value = '';
      document.getElementById('needDelivery').value = 'no';
      document.getElementById('deliveryNote').value = '';
      document.getElementById('eaves').value = '16';
      document.getElementById('seamType').value = 'single_fold';
      document.getElementById('clampLayout').value = 'every_other';
      document.getElementById('seamSpacing').value = '16';
      document.getElementById('pitch').value = '6';
      document.getElementById('rowCount').value = '1';
      calculateMaterials();
    }

    async function addAllToShopifyCart() {
      calculateMaterials();
      await loadShopifyPricesForMaterials(currentMaterials);
      if (getInputNumber('eaves') <= 0) return;
      const cartMessage = document.getElementById('cartMessage');
      cartMessage.style.display = 'block';
      cartMessage.className = 'message cart-message';
      cartMessage.textContent = 'Adding mapped ColorGard accessories to cart...';

      const items = currentMaterials
        .filter(function(item) { return (SHOPIFY_PRODUCTS[item.key] && SHOPIFY_PRODUCTS[item.key].variantId); })
        .map(function(item) {
          return {
            id: Number(SHOPIFY_PRODUCTS[item.key].variantId),
            quantity: Number(item.qty),
            properties: {
              Material: item.name,
              Unit: item.unit,
              Unit_Cost: item.unitCost === null ? 'Price unavailable' : money(item.unitCost),
              Project_Name: getInputText('projectName'),
              Project_Address: getInputText('projectAddress'),
              Seam_Type: SEAM_TYPE_LABELS[getInputText('seamType')],
              Clamp_Layout: LAYOUT_LABELS[getInputText('clampLayout')],
              Seam_Spacing: getInputText('seamSpacing') + ' inches',
              Pitch: getInputText('pitch') + '/12',
              Eaves_ft: String(getInputNumber('eaves')),
              Rows: String(selectedRowCount()),
              Delivery: getInputText('needDelivery'),
              Delivery_Note: getInputText('deliveryNote'),
              Delivery_Fee: money(deliveryFee())
            }
          };
        });

      if (!items.length) {
        cartMessage.className = 'message cart-message error';
        cartMessage.textContent = 'No Shopify variant IDs are mapped yet. Add real variant IDs to SHOPIFY_VARIANTS before using Add All to Cart.';
        return;
      }

      try {
        const response = await fetch('/cart/add.js', {
          method: 'POST',
          headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
          body: JSON.stringify({ items: items })
        });
        if (!response.ok) throw new Error('Shopify cart request failed.');
        cartMessage.className = 'message cart-message success';
        cartMessage.textContent = 'Mapped ColorGard accessories were added to cart.';
        window.setTimeout(function() { window.location.href = '/cart'; }, 900);
      } catch (error) {
        cartMessage.className = 'message cart-message error';
        cartMessage.textContent = 'Could not add materials to cart: ' + error.message;
      }
    }

    function pdfSafeFileName(value) {
      const cleaned = String(value || 'snow-retention-accessories')
        .trim()
        .replace(/[^a-z0-9\-_]+/gi, '-')
        .replace(/-+/g, '-')
        .replace(/^-|-$/g, '');
      return cleaned || 'snow-retention-accessories';
    }

    async function downloadPDF() {
      calculateMaterials();
      await loadShopifyPricesForMaterials(currentMaterials);
      if (getInputNumber('eaves') <= 0) return;

      if (!window.jspdf || !window.jspdf.jsPDF) {
        alert('PDF library is not loaded. Please check your internet connection and try again.');
        return;
      }

      const doc = new window.jspdf.jsPDF({ orientation: 'landscape', unit: 'pt', format: 'letter' });
      const pageWidth = doc.internal.pageSize.getWidth();
      const margin = 28;
      const projectName = getInputText('projectName') || 'Snow Retention Accessories';
      const projectAddress = getInputText('projectAddress') || '-';
      const generatedAt = new Date();
      const materialsSubtotal = currentMaterials.reduce(function(sum, item) { return sum + (item.totalCost || 0); }, 0);
      const delivery = deliveryFee();
      const taxableSubtotal = materialsSubtotal + delivery;
      const hst = taxableSubtotal * HST_RATE;
      const totalWithTax = taxableSubtotal + hst;
      const rows = currentMaterials.map(function(item) {
        return [item.name, String(item.qty), item.unit, item.unitCost === null ? 'N/A' : money(item.unitCost), item.totalCost === null ? 'N/A' : money(item.totalCost)];
      });

      doc.setFont('helvetica', 'bold');
      doc.setFontSize(15);
      doc.text('S-5! ColorGard Snow Retention Accessories', margin, 32);

      doc.setFontSize(10);
      doc.text('Quote Date: ' + generatedAt.toLocaleDateString(), pageWidth - margin, 32, { align: 'right' });

      const headerRows = [
        ['Project:', projectName],
        ['Project Address:', projectAddress],
        ['Seam Type:', SEAM_TYPE_LABELS[getInputText('seamType')]],
        ['Clamp Layout:', LAYOUT_LABELS[getInputText('clampLayout')]],
        ['Seam Spacing:', getInputText('seamSpacing') + ' inches'],
        ['Pitch:', getInputText('pitch') + '/12'],
        ['Eaves:', getInputNumber('eaves') + ' ft'],
        ['Rows:', String(selectedRowCount())],
        ['Delivery:', getInputText('needDelivery') === 'outside_gta' ? 'Outside GTA Toronto - $300' : (getInputText('needDelivery') === 'gta' ? 'GTA Toronto - Free' : 'No delivery')]
      ];

      doc.setFontSize(9);
      headerRows.forEach(function(row, index) {
        const y = 56 + index * 12;
        doc.setFont('helvetica', 'bold');
        doc.text(row[0], margin, y);
        doc.setFont('helvetica', 'normal');
        doc.text(String(row[1]), margin + 98, y);
      });

      const tableWidth = pageWidth - margin * 2;

      doc.autoTable({
        startY: 160,
        margin: { left: margin, right: margin },
        tableWidth: tableWidth,
        head: [['Accessory', 'Qty', 'Unit', 'Unit Cost', 'Total']],
        body: rows,
        theme: 'grid',
        styles: { font: 'helvetica', fontSize: 8, cellPadding: 4, overflow: 'linebreak', valign: 'top', lineWidth: 0.4 },
        headStyles: { fillColor: [249, 250, 251], textColor: [75, 85, 99], lineColor: [223, 227, 234], fontStyle: 'bold' },
        columnStyles: {
          0: { cellWidth: tableWidth - 340 },
          1: { cellWidth: 60, halign: 'right' },
          2: { cellWidth: 60 },
          3: { cellWidth: 110, halign: 'right' },
          4: { cellWidth: 110, halign: 'right' }
        }
      });

      const totalsY = doc.lastAutoTable.finalY + 20;
      const totalsLabelX = margin + tableWidth - 270;
      const totalsValueX = margin + tableWidth;
      doc.setFontSize(9);
      doc.setFont('helvetica', 'normal');
      doc.text('Materials subtotal:', totalsLabelX, totalsY);
      doc.text(money(materialsSubtotal), totalsValueX, totalsY, { align: 'right' });
      doc.text('Delivery:', totalsLabelX, totalsY + 14);
      doc.text(money(delivery), totalsValueX, totalsY + 14, { align: 'right' });
      doc.text('HST 13%:', totalsLabelX, totalsY + 28);
      doc.text(money(hst), totalsValueX, totalsY + 28, { align: 'right' });
      doc.setFont('helvetica', 'bold');
      doc.text('Total with tax:', totalsLabelX, totalsY + 42);
      doc.text(money(totalWithTax), totalsValueX, totalsY + 42, { align: 'right' });

      const disclaimer = 'This calculator provides an estimate only. Final quantities, clamp layout, and row requirements should be verified before ordering. Roof pitches 10/12 and higher require engineer review. Roof pitches above 11/12 may require two rows.';
      doc.setFont('helvetica', 'normal');
      doc.setFontSize(7.5);
      doc.text(doc.splitTextToSize(disclaimer, pageWidth - margin * 2), margin, totalsY + 70);

      doc.save(pdfSafeFileName(projectName) + '-snow-retention-accessories.pdf');
    }

    populatePitchOptions();
    populateSeamSpacingOptions();
    setupAutoCalculate();
    calculateMaterials();
